import { ref } from "vue";
import qbApi from '@/util/quickbooks.util';
import { checkQuickbooksAuth } from "@/util/functions";

export function useQuickbooksSetup() {
    const waiting = ref(false);
    const message = ref('');
    const isLoading = ref(true);
    const isSetup = ref(false);

    async function doLinkQuickbooks() {
        waiting.value = true;
        message.value = '';

        const tmpWindow = window.open(undefined, "quickbooks popup", "width=400,height=800,left=100,top=100");

        try {
            await qbApi.linkQuickbooks(tmpWindow);
        } catch (e) {
            if(e instanceof Error) {
                message.value = e.message;
            }
        } finally {
            waiting.value = false;
        }
    }

    async function checkIfAuthed() {
        isLoading.value = true;
        isSetup.value = false;
        const { data: res } = await checkQuickbooksAuth();
        isLoading.value = false;
        isSetup.value = res;
    }

    checkIfAuthed();

    return { waiting, message, doLinkQuickbooks, isLoading, isSetup }
}